import React, { useEffect, useState } from 'react'
import * as jnb from 'react-bootstrap';
import { ErrorMessage, Field, FieldArray, FormikProvider, useFormik } from 'formik';
import { BiTrash } from 'react-icons/bi';
import { VscDiffAdded } from 'react-icons/vsc';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../Header/Header';
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import CommonPost from '../../../CommonUtils/CommonAxios/CommonPost';
import { empFormValidations } from '../../../CommonUtils/Validations/Validations';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios/CommonAxios';
import Sweetalert, { failureAlert } from '../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import { useSelector } from 'react-redux';
import { allowCharsAndNumericMaxSpaces, handleKeyAlphaNumeric, handleKeyPressAlphabets, handleKeyPressNumeric, handleNumericDot, public_url } from '../../../CommonUtils/Validations/RegularExpAndVar';
import axios from 'axios';
import { BsChevronDown } from 'react-icons/bs';
import { useQuery } from '@tanstack/react-query';
export default function CESSPaymentScreen() {
    let navigate = useNavigate()
    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails);
    let location = useLocation()
    const paymentStatus = location?.state?.status
    const Id = location?.state?.Id
    // let RegisteredStatus = location?.state?.status
    let username = loginreducer?.loginData?.username
    const [showData, setData] = useState([])
    const [scode, setScode] = useState(null);
    function getdata() {
        let url = config.url.BOC_URL + "cess-payment-details?userId=" + username + "&id=" + Id;
        CommonAxiosGet(url).then((response) => {
            setScode(response.data.scode);
            if (response.data.status === true) {
                const Data = response.data.cessView[0];

                // Parse work_details
                const workDetails = JSON.parse(Data.work_details || "[]");
                Data.work_details = workDetails;

                // ✅ Parse payment_details
                const paymentDetails = JSON.parse(Data.payment_details || "[]");
                Data.payment_details = Array.isArray(paymentDetails)
                    ? paymentDetails.filter((p) => p !== null)
                    : [];


                // Set final structured data
                setData(Data);
            } else {
                setData([]);
            }
        });
    }

    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            userType: "",
            entryBy: username,
            regEstablishment: "",
            regNo: "",
            isPlanApproval: "",
            planApproNo: "",
            officeAddress: "",
            officeDoorNo: "",
            officePincode: "",
            officeVillageCode: "",
            officeMadalCode: "",
            officeDistrictCode: "",
            workExecution: "",
            ddoCode: "",
            ddoOfcName: "",
            ddoOfcAddress: "",
            ddoPhoneNo: "",
            ddoEmail: "",

            category: "",
            nameOfDept: "",
            positionName: "",
            agencyName: "",
            agencyAddress: "",
            agencyAuthPersonName: "",
            agencyPhnNo: "",
            agencyEmail: "",

            workdetails: [
                {
                    venderName: "",
                    workBillNo: "",
                    workAddress: "",
                    natureOfWork: "",
                    valueOfWork: "",
                    valueOfWorkPercentage: '',
                    phoneNo: "",
                },
            ],
            cessAmount: "",
            advanCessAmount: "",
            balancePayAmount: "",
            paymentType: "",
            RemainingAmount: "",
            paymentVendorName: ''
        },
        validationSchema: empFormValidations,
        onSubmit: (values) => {
            console.log("values", JSON.stringify(values));
            // submitpayvalues(Formik.values);
        },

        validationSchema: empFormValidations
    })

    const submitpayvalues = (values) => {
        CommonAxiosPost(config.url.BOC_URL + "cess-payment", values)
            .then((res) => {
                if (res.data.scode === "01") {
                    Sweetalert(res.data.sdesc, "success");
                    getdata();
                    let resData = res.data.encrypted_string;
                    let merchantId = res.data.merchant_id;

                    const form = document.createElement('form');
                    form.method = 'POST';
                    form.action = "https://test.epay.sbiuat.bank.in/secure/AggregatorHostedListener";

                    const inputMerchantId = document.createElement('input');
                    inputMerchantId.type = 'hidden';
                    inputMerchantId.name = 'merchIdVal';
                    inputMerchantId.id = 'merchIdVal';
                    inputMerchantId.value = merchantId;
                    form.appendChild(inputMerchantId);

                    const inputEncryption = document.createElement('input');
                    inputEncryption.type = 'hidden';
                    inputEncryption.name = 'EncryptTrans';
                    inputEncryption.id = 'EncryptTrans';
                    inputEncryption.value = resData;
                    form.appendChild(inputEncryption);

                    document.body.appendChild(form);
                    form.submit();
                }
                else {
                    failureAlert(res.data.sdesc, "error");
                }
            })
            .catch((err) => {
                console.log("Error at BOC", err);
                failureAlert("BOC request failed", "error");
            });
    }

    const [showDist, setDist] = useState([])
    const getDistDataFunction = () => {
        let url = config.url.BOC_URL + public_url + "listofdistricts";
        axios.get(url).then((response) => {
            setDist(response.data.districts);
        })
    };

    const [showOfficeManList, setOfficeManList] = useState([]);
    const [showOfficeDistCode, setOfficeDistCode] = useState("");
    const getOfficeMandalFunction = (e) => {
        setOfficeDistCode(e.target.value);
        // setOfficeManList(showDist.filter((val) => val.districtId === e.target.value)[0]?.mandals)
        const selectedDist = showDist.find(val => val.districtId === parseInt(e.target.value));
        setOfficeManList(selectedDist?.mandals)
    };
    const [showOfficeVillList, setOfficeVillList] = useState([]);
    const getOfficeVillageDataFunction = (e) => {
        let villUrl = config.url.BOC_URL + public_url + "new-villages?dist_code=" + showOfficeDistCode + "&mandal_code=" + e.target.value;
        axios.get(villUrl).then((response) => {
            setOfficeVillList(response.data?.villages);
        });
    };

    useEffect(() => {
        if (Id !== undefined) {
            getdata();
        } else { getDistDataFunction() }
    }, []);
    const [showDept, setDept] = useState([])
    // const [showDesignation, setDesignation] = useState([])
    const { data: Department } = useQuery({
        queryKey: ['boc-public/departments',],
        queryFn: () => CommonAxiosGet(config.url.BOC_URL + 'boc-public/departments'),
        // staleTime: 5 * 60 * 1000,
        staleTime: 60 * 60 * 1000,   // 1 hour in milliseconds
        cacheTime: 60 * 60 * 1000    // 1 hour in milliseconds
        // enabled: !!org_id, // Only fetch if org_id is truthy
    });
    // const { data: Designation } = useQuery({
    //     queryKey: ['boc-public/designations', Formik?.values?.nameOfDept],
    //     queryFn: () => CommonAxiosGet(config.url.BOC_URL + 'boc-public/designations?deptCode=' + Formik?.values?.nameOfDept),
    //     // staleTime: 5 * 60 * 1000,
    //     staleTime: 60 * 60 * 1000,   // 1 hour in milliseconds
    //     cacheTime: 60 * 60 * 1000,   // 1 hour in milliseconds
    //     // enabled: !!org_id, // Only fetch if org_id is truthy
    //     enabled: !!Formik?.values?.nameOfDept,
    // });

    useEffect(() => {
        if (!Formik?.values?.cessAmount && showData?.cess_amount) {
            Formik.setFieldValue("cessAmount", parseFloat(showData.cess_amount).toFixed(2));
        }
    }, [Formik.values.cessAmount, showData?.cess_amount]);

    useEffect(() => {
        if (Department?.data?.scode === "01") {
            setDept(Department?.data?.departments)
        } else { setDept([]) }
    }, [Department])
    const payment = (values) => {
        const payload = {
            entryBy: username,
            cessId: showData?.id,
            paymentType: Formik.values.paymentType,
            advanCessAmount: Formik.values.paymentType === 'F' ? showData?.remaining_amount : Formik.values.advanCessAmount,
            balancePayAmount: Formik.values.balancePayAmount,
            cessAmount: showData?.cess_amount
        }

        CommonAxiosPost(config.url.BOC_URL + "cess-payment-update", payload)
            .then((res) => {
                if (res.data?.scode === '01') {
                    let url = config.url.BOC_URL + "pay";
                    CommonAxiosGet(url).then((response) => {
                        if (response.data.status === false) {
                            navigate("/PaymentPage");
                        }
                        else {
                            let resData = res.data.encrypted_string;
                            let merchantId = res.data.merchant_id;

                            const form = document.createElement('form');
                            form.method = 'POST';
                            form.action = "https://test.epay.sbiuat.bank.in/secure/AggregatorHostedListener";

                            const inputMerchantId = document.createElement('input');
                            inputMerchantId.type = 'hidden';
                            inputMerchantId.name = 'merchIdVal';
                            inputMerchantId.id = 'merchIdVal';
                            inputMerchantId.value = merchantId;
                            form.appendChild(inputMerchantId);

                            const inputEncryption = document.createElement('input');
                            inputEncryption.type = 'hidden';
                            inputEncryption.name = 'EncryptTrans';
                            inputEncryption.id = 'EncryptTrans';
                            inputEncryption.value = resData;
                            form.appendChild(inputEncryption);

                            document.body.appendChild(form);
                            form.submit();
                        }
                    })
                        .catch((error) => {
                            console.log("Error during payment request:", error);
                        });
                } else if (res.data.scode === '02' || res.data.scode === '03') {
                    failureAlert(res.data.sdesc, 'warning');
                }
            })
            .catch((error) => {
                console.log("Error at BOC worker registration:", error);
            });

    }

    function clearAllFields() {
        Formik.setFieldValue("regEstablishment", "");
        Formik.setFieldValue("regNo", "");
        Formik.setFieldValue("isPlanApproval", "");
        Formik.setFieldValue("planApproNo", "");
        Formik.setFieldValue("officeDistrictCode", "");
        Formik.setFieldValue("officeMadalCode", "");
        Formik.setFieldValue("officeVillageCode", "");
        Formik.setFieldValue("officePincode", "");
        Formik.setFieldValue("officeDoorNo", "");
        Formik.setFieldValue("officeAddress", "");

        // Clear DDO-specific fields
        setddodata([]); 
        Formik.setFieldValue("ddoCode", "");
        Formik.setFieldValue("ddoOfcName", "");
        Formik.setFieldValue("ddoOfcAddress", "");
        Formik.setFieldValue("ddoPhoneNo", "");
        Formik.setFieldValue("ddoEmail", "");

        // Executing Agency fields
        Formik.setFieldValue("category", "");
        Formik.setFieldValue("nameOfDept", "");
        Formik.setFieldValue("positionName", "");
        Formik.setFieldValue("agencyName", "");
        Formik.setFieldValue("agencyAddress", "");
        Formik.setFieldValue("agencyAuthPersonName", "");
        Formik.setFieldValue("agencyPhnNo", "");
        Formik.setFieldValue("agencyEmail", "");
    }
    const calculateCess = (workdetails, formik) => {
        const totalWorkValue = workdetails.reduce((sum, row) => {
            const v = parseFloat(row.valueOfWork);
            return sum + (isNaN(v) ? 0 : v);
        }, 0);

        const cess = totalWorkValue * 0.01;
        formik.setFieldValue("cessAmount", cess.toFixed(2));
    };
     const [ddodata, setddodata] = useState([]);
     function getddodata(ddoCode) {
         let url = config.url.BOC_URL + "organisations?ddocode=" + ddoCode;
         CommonAxiosGet(url).then((response) => {
             if (response.data.status === true && response.data.scode === "01") {
                 setddodata(response.data.organisations);
             } else if(response.data.scode === "03") {
                Sweetalert("Invalid DDO Code. Try Again","error").then(()=>{
                    Formik.setFieldValue("ddoCode",'')
                })

             }else {
                 setddodata([]);
             }
         });
	     }
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="CESS Payment(సెస్ పేమెంట్)"
            // path="/DashBoardMain" 
            />
            <jnb.Container className="outer-page-content-container">
                <FormikProvider value={Formik}>
                    <jnb.Form onChange={Formik.handleChange} onSubmit={Formik.handleSubmit} className="form_adjust">
                        {/* {scode === "03" && ( */}
                        {!paymentStatus && (
                            <>
                                <div className="form-card-jnb" >
                                    <jnb.Row className="pt-0">
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="">
                                                <label className=' w-100 mb-1'>Are You Individual/Company/Contractor/DDO /Executing Agency?(మీరు వ్యక్తిగతం / సంస్థ / డీడీఓ / అమలు సంస్థనా?)</label>
                                                <Field as="select" id="userType" className="form-control w-100 mt-1" name="userType"
                                                    title="Select Name/Company/10 Digit DDO code/Agency(పేరు/సంస్థ/10 అంకెల డీడీఓ కోడ్/ఏజెన్సీని ఎంచుకోండి)"
                                                    onChange={() => {
                                                        clearAllFields()
                                                    }}
                                                >
                                                    <option value="0"> ---Select---</option>
                                                    <option value="Individual/Company"> Individual/Company/Contractor(వ్యక్తిగతం / సంస్థ)</option>
                                                    {/* <option value="Company"> Company</option> */}
                                                    <option value="DDO"> DDO(డీడీఓ)</option>
                                                    <option value="Executing Agency"> Executing Agency(అమలు సంస్థ)</option>
                                                </Field>
                                                {/* <BsChevronDown className='icon-inside-inputfiled' style={{ top: '54' }}></BsChevronDown> */}
                                                <ErrorMessage name="userType" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>

                                        {Formik?.values?.userType === "Individual/Company" && (
                                            <React.Fragment>
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >

                                                    <jnb.InputGroup className="mt-4">
                                                        <label>Registered as Establishment(స్థాపనగా నమోదు)</label>
                                                    </jnb.InputGroup>
                                                    <div className="form-control" title="Select the option (ఎంపికను ఎంచుకోండి)">
                                                        <Field type="radio" value="yes" name="regEstablishment"
                                                            onChange={() => {
                                                                Formik.setFieldValue("isPlanApproval", "")
                                                                Formik.setFieldValue("planApproNo", "")
                                                            }}
                                                        />&nbsp;Yes(అవును)&emsp;&emsp;
                                                        <Field type="radio" value="no" name="regEstablishment"
                                                            onChange={() => {
                                                                Formik.setFieldValue("regNo", "");
                                                                Formik.setFieldValue("isPlanApproval", "")
                                                                Formik.setFieldValue("planApproNo", "")
                                                            }}
                                                        />&nbsp;No(లేదు)
                                                        {Formik?.values?.regEstablishment === "no" && (<React.Fragment>
                                                            {/* <label style={{ color: "blue", fontSize: "17px" }} onClick={() => (navigate("/LabourDepartment"))}><u>Click Here </u></label> */}
                                                            <label
                                                                style={{ color: "blue", fontSize: "17px", cursor: "pointer" }}
                                                                onClick={() => window.open("https://ap.meeseva.gov.in/DeptPortal/UserInterface/LoginForm.aspx", "_blank")}
                                                            >
                                                                <u>select here to Register(నమోదు కోసం ఎంచుకోండి)</u>
                                                            </label>

                                                        </React.Fragment>)}
                                                    </div>
                                                    <ErrorMessage name="regEstablishment" component="div" className="text-error" />
                                                </jnb.Col>
                                                {Formik?.values?.regEstablishment === "yes" && (
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                        <jnb.InputGroup className="mt-4">
                                                            <label className=' w-100 mb-1'>Registration Number(నమోదు సంఖ్య)</label>

                                                            <Field type="text" id="regNo" className="form-control w-100" name="regNo" maxLength="12"
                                                                onKeyPress={(e) => handleKeyAlphaNumeric(e)}
                                                                onPaste={(e) => { e.preventDefault() }}
                                                                onDragStart={(e) => e.preventDefault()}
                                                                onDrop={(e) => e.preventDefault()}
                                                                title="Enter Sample number(నమోదు సంఖ్యను నమోదు చేయండి)" />
                                                            <ErrorMessage name="regNo" component="div" className="text-error" />
                                                        </jnb.InputGroup>
                                                    </jnb.Col>
                                                )}
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                    <jnb.InputGroup className="mt-4">
                                                        <label>Does this have plan approval(దీనికి ప్లాన్ అనుమతి)?</label>
                                                    </jnb.InputGroup>
                                                    <div className="form-control" title="Select DTCP/Panchayat Raj Plan Aprroval(DTCP/పంచాయితీ రాజ్ ప్రణాళిక ఆమోదాన్ని ఎంచుకోండి)">
                                                        <Field type="radio" value="yes" name="isPlanApproval"
                                                        />&nbsp;Yes(అవును)&emsp;&emsp;
                                                        <Field type="radio" value="no" name="isPlanApproval" />&nbsp;No(లేదు)
                                                    </div>
                                                    <ErrorMessage name="isPlanApproval" component="div" className="text-error" />
                                                </jnb.Col>
                                                {Formik?.values?.isPlanApproval === "yes" && (
                                                    <>
                                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mt-3'>
                                                            <jnb.InputGroup className="">
                                                                <label className=' w-100 mb-1'>Plan Approval Number(ప్రణాళిక అనుమతి సంఖ్య)</label>

                                                                <Field type="text" id="planApproNo" className="form-control w-100 mt-1" name="planApproNo" maxLength="12"
                                                                    onKeyPress={(e) => handleKeyPressNumeric(e)}
                                                                    onPaste={(e) => { e.preventDefault() }}
                                                                    onDragStart={(e) => e.preventDefault()}
                                                                    onDrop={(e) => e.preventDefault()}
                                                                    title="Enter Sample Number(సాంపిల్ నంబర్ నమోదు చేయండి)" />
                                                                <ErrorMessage name="planApproNo" component="div" className="text-error" />
                                                            </jnb.InputGroup>
                                                        </jnb.Col>
                                                        <div className="inner-herbpage-service-title-sub mt-3">
                                                            <h1>Building Location Address(భవనం చిరునామా)</h1>
                                                        </div>
                                                        <div className="form-card-jnb border mt-2" >
                                                            <jnb.Row className="pt-0 px-2 mt-3">
                                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                                    <jnb.InputGroup className="">
                                                                        <label className=' w-100 mb-1'>District(జిల్లా)</label>
                                                                        <Field as="select" name="officeDistrictCode" className="form-control w-100 nb-1"
                                                                            onChange={(e) => {
                                                                                getOfficeMandalFunction(e)
                                                                                Formik.setFieldValue('officeMadalCode', '')
                                                                                Formik.setFieldValue('officeVillageCode', '')
                                                                                //  ClearFunction('madalCode','');
                                                                                //  ClearFunction('secretariat','');
                                                                                //  ClearFunction('villageCode','')
                                                                            }}
                                                                            title="Select district (జిల్లాను ఎంచుకోండి)"
                                                                        >
                                                                            <option value="">--Select--</option>
                                                                            {showDist !== undefined && showDist.map((ds, i) => {
                                                                                return (<option key={i} value={ds.districtId}>{ds.distName}</option>);
                                                                            })}
                                                                        </Field>
                                                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                                        <ErrorMessage name="officeDistrictCode" component="div" className="text-error" />
                                                                    </jnb.InputGroup>
                                                                </jnb.Col>
                                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                                    <jnb.InputGroup className="">
                                                                        <label className=' w-100 mb-1'>Mandal(మండలం)</label>
                                                                        <Field as="select" name="officeMadalCode" className="form-control w-100"
                                                                            onChange={(e) => { //getSecretrait(e);
                                                                                getOfficeVillageDataFunction(e);
                                                                                Formik.setFieldValue('officeVillageCode', '')
                                                                                // ClearFunction('secretariat','');ClearFunction('villageCode','')
                                                                            }} title="Select mandal (మండలాన్ని ఎంచుకోండి)"
                                                                        >
                                                                            <option value="">--Select--</option>
                                                                            {showOfficeManList !== undefined && showOfficeManList.map((ms, i) => {

                                                                                return (<option key={i} value={ms.mandalCode}>{ms.mandalName}</option>);
                                                                            })}
                                                                        </Field>
                                                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                                        <ErrorMessage name="officeMadalCode" component="div" className="text-error" />
                                                                    </jnb.InputGroup>
                                                                </jnb.Col>
                                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                                    <jnb.InputGroup className="">
                                                                        <label className=' w-100 mb-1'>Village(గ్రామం)</label>
                                                                        <Field as="select" name="officeVillageCode" className="form-control w-100 mt-1"
                                                                            title="Select village (గ్రామాన్ని ఎంచుకోండి)"
                                                                        >
                                                                            <option value="">--Select--</option>
                                                                            {showOfficeVillList !== undefined && showOfficeVillList.map((vs, i) => {
                                                                                return (<option key={i} value={vs.village_code}>{vs.village_name}</option>);
                                                                            })}

                                                                        </Field>
                                                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                                                        <ErrorMessage name="officeVillageCode" component="div" className="text-error" />
                                                                    </jnb.InputGroup>
                                                                </jnb.Col>
                                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                                    <jnb.InputGroup className="">
                                                                        <label >Pincode(పిన్ కోడ్)</label>
                                                                        <Field type="text" className="form-control w-100 mt-1" name="officePincode" maxLength="6"
                                                                            onKeyPress={(e) => handleKeyPressNumeric(e)}
                                                                            onPaste={(e) => { e.preventDefault() }}
                                                                            onDragStart={(e) => e.preventDefault()}
                                                                            onDrop={(e) => e.preventDefault()}
                                                                            title="Enter the Pincode (పిన్ కోడ్ నమోదు చేయండి)" />
                                                                        <ErrorMessage name="officePincode" component="div" className="text-error" />
                                                                    </jnb.InputGroup>
                                                                </jnb.Col>
                                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                                    <jnb.InputGroup className="">
                                                                        <label className=' w-100 mb-1'>Door No(ఇంటి నంబర్)</label>
                                                                        <Field type="text" className="form-control w-100 mt-1" name="officeDoorNo" maxLength="15" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                                            onKeyPress={(e) => allowCharsAndNumericMaxSpaces(e)}
                                                                            title="Enter the Door Number(ఇంటి నంబర్ నమోదు చేయండి)" />
                                                                        <ErrorMessage name="officeDoorNo" component="div" className="text-error" />
                                                                    </jnb.InputGroup>
                                                                </jnb.Col>
                                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                                                    <jnb.InputGroup className="">
                                                                        <label className=' w-100 mb-1'>Address(చిరునామా)</label>
                                                                        <Field as="textarea" id="officeAddress" name="officeAddress" rows={1} maxLength="100" className="form-control w-100 my-1" cols={50} onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                                                            title="Enter the Address(చిరునామా నమోదు చేయండి)"
                                                                        ></Field>
                                                                        <ErrorMessage name="officeAddress" component="div" className="text-error" />
                                                                    </jnb.InputGroup>
                                                                </jnb.Col>

                                                            </jnb.Row>
                                                        </div>
                                                    </>
                                                )}
                                            </React.Fragment>
                                        )}
                                        {Formik?.values?.userType === "DDO" && (
                                            <React.Fragment>
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                    <jnb.InputGroup className="mt-4">
                                                        <label title="Enter the DDO Code (డీడీఓ కోడ్ నమోదు చేయండి)">DDO Code(డీడీఓ కోడ్)</label>
                                                        <Field type="text" id="ddoCode" className="form-control w-100" name="ddoCode" maxLength="11"
                                                            onKeyPress={(e) => handleKeyPressNumeric(e)}
                                                            onPaste={(e) => { e.preventDefault() }}
                                                            onDragStart={(e) => e.preventDefault()}
                                                            onDrop={(e) => e.preventDefault()}
                                                            title="Enter the DDO Code (డీడీఓ కోడ్ నమోదు చేయండి)"
                                                             onChange={(e) => {
                                                                 const ddocode = e?.target?.value?.toUpperCase();
                                                                 e.target.value = ddocode;
                                                                 if (e.target.value.length === 11) {
                                                                     getddodata(ddocode);
                                                                 }
                                                                 else {
                                                                     setddodata([]);                         
                                                                     Formik.setFieldValue("ddoOfcName", "");
                                                                 }
	                                                             }} />
                                                        <ErrorMessage name="ddoCode" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                    <jnb.InputGroup className="mt-4">
                                                        <label className=' w-100 mb-1'>Office Name(కార్యాలయ పేరు)</label>
                                                        <Field as="select" id="ddoOfcName" placeholder="Office Name" className="form-control w-100" name="ddoOfcName" maxLength="30"
                                                            // onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                                            // onPaste={(e) => { e.preventDefault() }}
                                                            // onDragStart={(e) => e.preventDefault()}
                                                            // onDrop={(e) => e.preventDefault()}
                                                            title="Enter the Office Name(కార్యాలయ పేరు నమోదు చేయండి)"
                                                        >
                                                            <option value="">--- Select Office ---</option>
                                                             {ddodata && ddodata.map((org) => (
                                                                 <option key={org.org_id} value={org.org_name}>
                                                                     {org.org_name}
                                                                 </option>
                                                             ))}
	                                                         </Field>
                                                        <ErrorMessage name="ddoOfcName" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                    <jnb.InputGroup className="mt-4">
                                                        <label className=' w-100 mb-1'>Office Address(కార్యాలయ చిరునామా)</label>
                                                        <Field as="textarea" name="ddoOfcAddress" rows={1} className="form-control w-100 my-1" cols={50}
                                                            title="Enter the Office Address (కార్యాలయ చిరునామా నమోదు చేయండి)"
                                                        ></Field>
                                                        <ErrorMessage name="ddoOfcAddress" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>

                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                    <jnb.InputGroup className="mt-1">
                                                        <label className=' w-100 mb-1'>Phone No(ఫోన్ నంబర్).</label>

                                                        <Field type="text" id="ddoPhoneNo" placeholder="xxxxxx" className="form-control w-100" name="ddoPhoneNo" maxLength="10"
                                                            onKeyPress={(e) => handleKeyPressNumeric(e)}
                                                            onPaste={(e) => { e.preventDefault() }}
                                                            onDragStart={(e) => e.preventDefault()}
                                                            onDrop={(e) => e.preventDefault()} title="Enter Phone Number (ఫోన్ నంబర్ నమోదు చేయండి)"
                                                        />
                                                        <ErrorMessage name="ddoPhoneNo" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>


                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                    <jnb.InputGroup className="">
                                                        <label className=' w-100 mb-1'>Email(ఈమెయిల్)</label>

                                                        <Field type="text" placeholder="example@email.com" className="form-control w-100 mt-1" name="ddoEmail"
                                                            title="Enter Email(ఈమెయిల్ నమోదు చేయండి)"
                                                        />
                                                        <ErrorMessage name="ddoEmail" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                            </React.Fragment>
                                        )}
                                        {Formik?.values?.userType === "Executing Agency" && (
                                            <React.Fragment>
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="">
                                                    <jnb.InputGroup className="mt-4">
                                                        <label className="w-100 mb-1">
                                                            Category(వర్గం)
                                                        </label>
                                                        <Field
                                                            as="select"
                                                            name="category"
                                                            className="form-control w-100 nb-1"
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                Formik.setFieldValue("category", value);
                                                                Formik.setFieldValue("nameOfDept", "");
                                                                Formik.setFieldValue("positionName", "");
                                                            }}
                                                            title="Select Category(వర్గం ఎంచుకోండి)"
                                                        >
                                                            <option value="">-- Select Category --</option>
                                                            <option value="State Government">State Government(రాష్ట్ర ప్రభుత్వం)</option>
                                                            <option value="State Government Undertaking">  State Government Undertaking( రాష్ట్ర ప్రభుత్వ ఆధీన సంస్థ)</option>
                                                            <option value="Central Government">Central Government(కేంద్ర ప్రభుత్వం)</option>
                                                            <option value="State Central Government Undertaking"> Central Government Undertaking(కేంద్ర ప్రభుత్వం ఉపక్రమం)</option>
                                                            <option value="Autonomous Body">Autonomous Body(స్వయంప్రతిపత్తి సంస్థ)</option>
                                                            {/* <option value="Private-Commercial">Private-Commercial(ప్రైవేట్-వాణిజ్య)</option> */}
                                                        </Field>
                                                        <ErrorMessage
                                                            name="category"
                                                            component="div"
                                                            className="text-error"
                                                        />

                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                                {Formik?.values?.category && (
                                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
                                                        <jnb.InputGroup className="mt-4">
                                                            <label className='w-100 mb-1'>Name of the Department(శాఖ పేరు)</label>
                                                        </jnb.InputGroup>
                                                        {/* <Field
                                                            type="text"
                                                            name="nameOfDept"
                                                            className="form-control w-100"
                                                            placeholder="Enter Department Name"
                                                            onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                                            maxLength='30'
                                                            title="Enter Name of the Department(శాఖ పేరు నమోదు చేయండి)" /> */}
                                                        <Field
                                                            as="select"
                                                            name="nameOfDept"
                                                            className="form-control w-100 nb-1"
                                                            title="Select department(శాఖను ఎంచుకోండి)"
                                                            onChange={() => { Formik.setFieldValue("positionName", ""); }}
                                                        >
                                                            <option value="">--Select--</option>
                                                            {showDept?.map((dept, i) => (
                                                                <option key={i} value={dept.deptcode}>
                                                                    {dept.dept_name}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        <ErrorMessage name="nameOfDept" component="div" className="text-error" />
                                                    </jnb.Col>
                                                )}
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                    <jnb.InputGroup className="mt-4">
                                                        <label className=' w-100 mb-1'>Agency Name(ఏజెన్సీ పేరు)</label>

                                                        <Field type="text" id="agencyName" className="form-control w-100" name="agencyName" maxLength="30"
                                                            onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                                            onPaste={(e) => { e.preventDefault() }}
                                                            onDragStart={(e) => e.preventDefault()}
                                                            onDrop={(e) => e.preventDefault()}
                                                            title="Enter Agency Name (ఏజెన్సీ పేరు నమోదు చేయండి)"
                                                        />
                                                        <ErrorMessage name="agencyName" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
                                                    <jnb.InputGroup className="mt-4">
                                                        <label className=' w-100 mb-1'>Agency Address(ఏజెన్సీ చిరునామా)</label>
                                                        <Field type="text" id="agencyAddress" className="form-control w-100" name="agencyAddress" title="Enter Agency Address (ఏజెన్సీ చిరునామా నమోదు చేయండి)" />
                                                        <ErrorMessage name="agencyAddress" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>

                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
                                                    <jnb.InputGroup className="mt-4">
                                                        <label className=' w-100 mb-1'>Authorised Person Name(అధికృత వ్యక్తి పేరు)</label>
                                                        <Field type="text" id="agencyAuthPersonName" className="form-control w-100" name="agencyAuthPersonName" maxLength="30" title="Enter Authorised Person Name (అధికృత వ్యక్తి పేరును నమోదు చేయండి)"
                                                            onKeyPress={(e) => handleKeyPressAlphabets(e)} onPaste={(e) => { e.preventDefault() }}
                                                            onDragStart={(e) => e.preventDefault()}
                                                            onDrop={(e) => e.preventDefault()} />
                                                        <ErrorMessage name="agencyAuthPersonName" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>

                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
                                                    <jnb.InputGroup className="mt-1">
                                                        <label htmlFor="agencyPhnNo">Phone No(ఫోన్ నంబర్)</label> <Field type="text" id="agencyPhnNo" className="form-control w-100" name="agencyPhnNo" maxLength="10" title="Enter Phone Number (ఫోన్ నంబర్ నమోదు చేయండి)" onKeyPress={(e) => handleKeyPressNumeric(e)} onPaste={(e) => { e.preventDefault() }}
                                                            onDragStart={(e) => e.preventDefault()}
                                                            onDrop={(e) => e.preventDefault()} />
                                                        <ErrorMessage name="agencyPhnNo" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>

                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
                                                    <jnb.InputGroup className="">
                                                        <label className=' w-100 mb-1'>Email(ఈమెయిల్)</label>
                                                        <Field type="text" className="form-control w-100 mt-1" name="agencyEmail" title="Enter Email Address (ఈమెయిల్ చిరునామా నమోదు చేయండి)" />
                                                        <ErrorMessage name="agencyEmail" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>

                                            </React.Fragment>
                                        )}
                                    </jnb.Row>
                                    <jnb.Row className="pt-1">
                                        <div className="inner-herbpage-service-title-sub">
                                            <h1>Work Details(పని వివరాలు)</h1>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                                                style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                                            >
                                                <thead style={{ border: "1px solid black" }}>
                                                    <tr>
                                                        <th>Vendor Name(వెండర్ పేరు)</th>
                                                        <th>Work Agreement Number/Id(పని ఒప్పంద సంఖ్య / ఐడీ) </th>
                                                        <th>Phone Number(ఫోన్ నంబర్)</th>
                                                        <th>Work Address(పని చిరునామా) </th>
                                                        <th>Nature of Work (పనుల స్వభావం)</th>
                                                        <th>Value of Work(పనికి విలువ)</th>
                                                        <th>1% Of value of work</th>
                                                        <th >Add<br />(చేర్చండి)</th>
                                                        {/* <th >Action</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <FieldArray name="workdetails">
                                                        {(formikFieldArray) => {
                                                            return formikFieldArray.form.values.workdetails.map((experienceDetails, index) => {
                                                                return (

                                                                    <tr key={index} id={index}>
                                                                        <td>
                                                                            <jnb.InputGroup className="">
                                                                                <Field type="text" autoComplete="off" className="form-control" name={`workdetails[${index}].venderName`}
                                                                                    onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                                                                    onChange={(e) => e.target.value = e.target.value.toUpperCase()}
                                                                                    onPaste={(e) => { e.preventDefault() }}
                                                                                    onDragStart={(e) => e.preventDefault()}
                                                                                    onDrop={(e) => e.preventDefault()}
                                                                                    maxLength='20'
                                                                                    title="Enter Builder/Owner Name(వెండర్ పేరును నమోదు చేయండి)"

                                                                                />
                                                                                <ErrorMessage name={`workdetails[${index}].venderName`} component="div" className="text-error" /></jnb.InputGroup> </td>
                                                                        <td>
                                                                            <jnb.InputGroup className="">
                                                                                <Field type="text" autoComplete="off" className="form-control" name={`workdetails[${index}].workBillNo`}
                                                                                    onKeyPress={(e) => handleKeyPressNumeric(e)} maxLength='12'
                                                                                    onPaste={(e) => { e.preventDefault() }}
                                                                                    onDragStart={(e) => e.preventDefault()}
                                                                                    onDrop={(e) => e.preventDefault()}
                                                                                    title="Enter Work Bill Agreement Number or ID(పని బిల్ ఒప్పంద సంఖ్య లేదా ఐడీ నమోదు చేయండి)" />
                                                                                <ErrorMessage name={`workdetails[${index}].workBillNo`} component="div" className="text-error" /></jnb.InputGroup> </td>
                                                                        <td>
                                                                            <jnb.InputGroup className="">
                                                                                <Field type="text" autoComplete="off" className="form-control" name={`workdetails[${index}].phoneNo`}
                                                                                    title="Enter Phone Number (ఫోన్ నంబర్ నమోదు చేయండి)" maxLength='10'
                                                                                    onKeyPress={(e) => handleKeyPressNumeric(e)}
                                                                                    onPaste={(e) => { e.preventDefault() }}
                                                                                    onDragStart={(e) => e.preventDefault()}
                                                                                    onDrop={(e) => e.preventDefault()} />
                                                                                <ErrorMessage name={`workdetails[${index}].phoneNo`} component="div" className="text-error" /></jnb.InputGroup> </td>

                                                                        <td>
                                                                            <jnb.InputGroup className="">
                                                                                <Field type="text" autoComplete="off" className="form-control" name={`workdetails[${index}].workAddress`}
                                                                                    title="Enter Work Address (పని చిరునామా నమోదు చేయండి)" />
                                                                                <ErrorMessage name={`workdetails[${index}].workAddress`} component="div" className="text-error" /></jnb.InputGroup> </td>
                                                                        <td>
                                                                            <jnb.InputGroup className="">
                                                                                {/* <Field type="text" autoComplete="off" className="form-control" name={`workdetails[${index}].natureOfWork`}
                                                                                    onKeyPress={(e) => handleKeyPressAlphabets(e)} maxLength='30'
                                                                                /> */}
                                                                                <Field
                                                                                    as="select"
                                                                                    name={`workdetails[${index}].natureOfWork`}
                                                                                    className="form-control w-100 nb-1"
                                                                                    title="Select Construction/Alteration/Repair/Maintenance/Demolishing(నిర్మాణం/మార్పు/పరిశీలన/నిర్వహణ/ధ్వంసం ఎంచుకోండి)" >
                                                                                    <option value="">--Select Nature of Work --</option>
                                                                                    <option value="Construction">Construction(నిర్మాణం)</option>
                                                                                    <option value="Alteration">Alteration(మార్పు)</option>
                                                                                    <option value="Repair">Repair(బాగుచేయడం)</option>
                                                                                    <option value="Maintenance">Maintenance(నిర్వహణ)</option>
                                                                                    <option value="Demolishing">Demolishing(కూల్చివేత)</option>
                                                                                </Field>
                                                                                <ErrorMessage name={`workdetails[${index}].natureOfWork`} component="div" className="text-error" /></jnb.InputGroup> </td>
                                                                        <td>
                                                                            <jnb.InputGroup className="">
                                                                                <Field
                                                                                    type="text"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name={`workdetails[${index}].valueOfWork`}
                                                                                    onKeyPress={(e) => handleKeyPressNumeric(e)}
                                                                                    onPaste={(e) => { e.preventDefault() }}
                                                                                    onDragStart={(e) => e.preventDefault()}
                                                                                    onDrop={(e) => e.preventDefault()}
                                                                                    title="Enter Construction Cost(నిర్మాణ ఖర్చును నమోదు చేయండి)"
                                                                                    onChange={(e) => {
                                                                                        const value = e.target.value;
                                                                                        const parsedValue = parseFloat(value) || 0;

                                                                                        // Update the current row's valueOfWork
                                                                                        formikFieldArray.form.setFieldValue(`workdetails[${index}].valueOfWork`, parsedValue);

                                                                                        // Get the updated workdetails array
                                                                                        const updatedWorkDetails = [...formikFieldArray.form.values.workdetails];
                                                                                        updatedWorkDetails[index].valueOfWork = parsedValue;

                                                                                        const valueOfWorkPercentage = parseFloat(parsedValue) * 0.01

                                                                                        formikFieldArray.form.setFieldValue(`workdetails[${index}].valueOfWorkPercentage`, valueOfWorkPercentage);
                                                                                        calculateCess(updatedWorkDetails, formikFieldArray.form);
                                                                                    }}

                                                                                />

                                                                                {/* <Field type="text" autoComplete="off" className="form-control" name={`workdetails[${index}].valueOfWork`} /> */}
                                                                                <ErrorMessage name={`workdetails[${index}].valueOfWork`} component="div" className="text-error" /></jnb.InputGroup> </td>

                                                                        <td>
                                                                            <jnb.InputGroup className="mt-0">
                                                                                <Field
                                                                                    type="text"
                                                                                    id={`workdetails[${index}].valueOfWorkPercentage`}
                                                                                    className="form-control w-100"
                                                                                    name={`workdetails[${index}].valueOfWorkPercentage`}
                                                                                    readOnly
                                                                                    maxLength="10"
                                                                                    disabled
                                                                                    title="a form of tax levied by the government on tax with specific purposes till the time the government gets enough money for that purpose
                                                     (సెస్ అనేది ప్రభుత్వం ఒక నిర్దిష్ట అవసరానికి మాత్రమే విధించే ప్రత్యేక పన్ను. అవసరమైన మొత్తాన్ని పొందిన తరువాత, దాన్ని రద్దు చేస్తారు.)"
                                                                                />
                                                                            </jnb.InputGroup>
                                                                        </td>
                                                                        <td onClick={() => Formik.setFieldValue('paymentType', '')}>
                                                                            {index === 0 ? (
                                                                                <React.Fragment>
                                                                                    <button type="button" className="button-titile btn btn-sm btn-success"
                                                                                        title="Click to Add Multilple work details(అనేక పని వివరాలు జోడించడానికి క్లిక్ చేయండి)"
                                                                                        onClick={() => formikFieldArray.push({
                                                                                            venderName: "",
                                                                                            workBillNo: "",
                                                                                            workAddress: "",
                                                                                            natureOfWork: "",
                                                                                            valueOfWork: "",
                                                                                        })}  > <VscDiffAdded style={{ fontSize: "20px" }}></VscDiffAdded>
                                                                                    </button>
                                                                                </React.Fragment>) : ("")}
                                                                            {index !== 0 ? (
                                                                                <React.Fragment>
                                                                                    <button type="button" className="button-titile btn btn-sm btn-danger"
                                                                                        onClick={() => {
                                                                                            const currentList = formikFieldArray.form.values.workdetails;
                                                                                            const updatedList = currentList.filter((_, i) => i !== index);
                                                                                            calculateCess(updatedList, formikFieldArray.form);
                                                                                            formikFieldArray.remove(index)

                                                                                        }}
                                                                                    ><BiTrash style={{ fontSize: "20px" }}></BiTrash></button>
                                                                                </React.Fragment>) : ("")} </td>
                                                                    </tr>
                                                                );
                                                            });
                                                        }}
                                                    </FieldArray>

                                                </tbody>
                                            </table>
                                        </div>

                                    </jnb.Row>
                                    <jnb.Row className="pt-1">
                                        <div className="inner-herbpage-service-title-sub">
                                            <h1>Payment Details(చెల్లింపు వివరాలు)</h1>
                                        </div>
                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="mt-0">
                                                <label className=' w-100 mb-1'>CESS Amount(సెస్ మొత్తం)</label>
                                                <Field
                                                    type="text"
                                                    id="cessAmount"
                                                    className="form-control w-100"
                                                    name="cessAmount"
                                                    readOnly
                                                    maxLength="10"
                                                    disabled
                                                    title="a form of tax levied by the government on tax with specific purposes till the time the government gets enough money for that purpose
                                                     (సెస్ అనేది ప్రభుత్వం ఒక నిర్దిష్ట అవసరానికి మాత్రమే విధించే ప్రత్యేక పన్ను. అవసరమైన మొత్తాన్ని పొందిన తరువాత, దాన్ని రద్దు చేస్తారు.)"
                                                />
                                                {/* <Field type="text" id="cessAmount" className="form-control w-100" name="cessAmount" maxLength="10" /> */}
                                                <ErrorMessage name="cessAmount" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>


                                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                            <jnb.InputGroup className="mt-0">
                                                <label className=' w-100 mb-1'>Payment Type(చెల్లింపు రకం)</label>
                                            </jnb.InputGroup>


                                            <div className="form-control" title="Select the Payment Type (చెల్లింపు రకం ఎంచుకోండి)">
                                                {/* <Field type="radio" value="F" name="paymentType"  onChange={(e) => {
        Formik.setFieldValue("paymentType", "F");
        Formik.setFieldValue("partialAmount", ""); // reset
        Formik.setFieldValue("balancePayAmount", "0");
      }}
                                                /> */}
                                                <Field
                                                    type="radio"
                                                    value="F"
                                                    name="paymentType"
                                                    onChange={(e) => {
                                                        const cessAmount = parseFloat(Formik.values.cessAmount) || 0;
                                                        Formik.setFieldValue("paymentType", "F");
                                                        Formik.setFieldValue("advanCessAmount", cessAmount.toFixed(2));
                                                        Formik.setFieldValue("balancePayAmount", "0.00");
                                                        Formik.setFieldValue("paymentVendorName", "");
                                                    }}
                                                />


                                                &nbsp;Full(పూర్తి)&emsp;&emsp;
                                                <Field type="radio" value="P" name="paymentType" onChange={(e) => {
                                                    Formik.setFieldValue("paymentType", "P");
                                                    Formik.setFieldValue("balancePayAmount", ""); // wait for partialAmount input
                                                    Formik.setFieldValue("advanCessAmount", "");
                                                    Formik.setFieldValue("paymentVendorName", "");
                                                }} />&nbsp;Partial(భాగంగా)
                                            </div>

                                            {/* <Field type="text" id="advanCessAmount" className="form-control w-100" name="advanCessAmount" maxLength="10" /> */}
                                            <ErrorMessage name="paymentType" component="div" className="text-error" />

                                        </jnb.Col>

                                        {Formik.values.paymentType === "P" && (<>
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                <jnb.InputGroup className="mt-0">
                                                    <label className='w-100 mb-1'>Select Vendor Name(వెండర్ పేరు)</label>
                                                </jnb.InputGroup>
                                                <Field as="select" name="paymentVendorName" className="form-control w-100"
                                                    onChange={(e) => { Formik.setFieldValue('advanCessAmount', '') }}
                                                >
                                                    <option value="">--Select--</option>
                                                    {Formik?.values?.workdetails !== undefined && Formik?.values?.workdetails.map((vendor, i) => {

                                                        return (<option key={i} value={vendor.venderName}>{vendor.venderName}</option>);
                                                    })}
                                                </Field>
                                                <ErrorMessage name="paymentVendorName" component="div" className="text-error" />
                                            </jnb.Col>
                                            {Formik.values.paymentVendorName !== '' && (
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                                    <jnb.InputGroup className="mt-0">
                                                        <label className='w-100 mb-1'>Advance Paid CESS Amount(ముందస్తుగా చెల్లించిన సెస్ మొత్తం)</label>
                                                    </jnb.InputGroup>
                                                    <Field
                                                        type="text"
                                                        name="advanCessAmount"
                                                        className="form-control"
                                                        onKeyPress={(e) => handleNumericDot(e)}
                                                        onPaste={(e) => { e.preventDefault() }}
                                                        onDragStart={(e) => e.preventDefault()}
                                                        onDrop={(e) => e.preventDefault()}
                                                        onChange={(e) => {
                                                            const value = parseFloat(e.target.value) || 0;
                                                            const cess = parseFloat(Formik.values.cessAmount) || 0;
                                                            const balance = (cess - value).toFixed(2);
                                                            Formik.setFieldValue("advanCessAmount", value);
                                                            Formik.setFieldValue("balancePayAmount", balance >= 0 ? balance : "");
                                                        }}
                                                        title="Enter the advance amount already paid towards CESS(ఇప్పటికే చెల్లించిన సెస్ ముందస్తు మొత్తాన్ని నమోదు చేయండి)"
                                                    />
                                                    <ErrorMessage name="advanCessAmount" component="div" className="text-error" />
                                                </jnb.Col>
                                            )}

                                        </>)}
                                        {(Formik?.values?.paymentType === "P" || Formik?.values?.paymentType === "F") && (
                                            <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
                                                <jnb.InputGroup className="mt-0">
                                                    <label className=' w-100 mb-1'>Balance Payable Amount(చెల్లించాల్సిన మిగతా మొత్తం)</label>
                                                </jnb.InputGroup>
                                                <Field
                                                    type="text"
                                                    className="form-control w-100"
                                                    name="balancePayAmount"
                                                    readOnly
                                                    disabled
                                                    title="Remaining amount to be paid towards CESS (CESS కు చెల్లించాల్సిన మిగతా మొత్తం)"
                                                />
                                                <ErrorMessage name="balancePayAmount" component="div" className="text-error" />
                                            </jnb.Col>)}
                                    </jnb.Row>
                                    {showData?.payment_type !== 'F' && (
                                        <div className='text-end mt-4'>
                                            <button type="submit" className="btn btn-primary btn-md"
                                                title="Click to proceed with payment(చెల్లింపును కొనసాగించండి)"
                                                onClick={() => {
                                                    submitpayvalues(Formik.values);
                                                }}
                                            >Pay Now(చెల్లించండి)</button>
                                        </div>
                                    )}
                                </div>

                            </>
                        )}
                        {/* {scode === "01" && showData && ( */}
                        {(paymentStatus === 'P' || paymentStatus === 'S') && (
                            <>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Individual/Company Details (వ్యక్తిగతం/కంపెనీ వివరాలు)</h1>
                                </div>

                                <div className="personal-row personal-roweducation">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                            <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                <tr>
                                                    <td>Are You Individual/Company/Contractor/DDO/Executing Agency? (మీరు వ్యక్తిగతం/కంపెనీ/డీడీఓ/అమలు సంస్థా?)</td>
                                                    <th colSpan={3}>{showData.usertype || "N/A"}</th>
                                                </tr>
                                                {showData.reg_establishment === "yes" && (
                                                    <tr>
                                                        <td>Registration Number (నమోదు సంఖ్య)</td>
                                                        <th>{showData.reg_no || "N/A"}</th>
                                                        <td>Registered as Establishment (సంస్థగా నమోదై ఉన్నారా?)</td>
                                                        <th>{showData.reg_establishment === "yes" ? "Yes (అవును)" : showData.reg_establishment === "no" ? "No (లేదు)" : "N/A"}</th>
                                                    </tr>
                                                )}
                                                <tr>

                                                    {showData.plan_approval === "yes" && (
                                                        <>
                                                            <td>Plan Approval (ప్లాన్ అనుమతి)</td>
                                                            <th>{showData.plan_approval === "yes" ? "Yes (అవును)" : showData.plan_approval === "no" ? "No (లేదు)" : "N/A"}</th>
                                                            <td>Plan Approval Number (ప్లాన్ అనుమతి సంఖ్య)</td>
                                                            <th>{showData.plan_appro_no || "N/A"}</th>
                                                        </>
                                                    )}
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {showData.usertype === "DDO" && (
                                    <div className="inner-herbpage-service-title-sub">
                                        <h1>DDO Details (డీడీఓ వివరాలు)</h1>
                                    </div>
                                )}

                                {showData.usertype === "DDO" && (
                                    <div className="personal-row personal-roweducation">
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped">
                                                <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                    <tr>
                                                        <td>DDO Code (డీడీఓ కోడ్)</td>
                                                        <th>{showData.ddo_code || "N/A"}</th>
                                                        <td>Office Name (కార్యాలయ పేరు)</td>
                                                        <th>{showData.ddo_ofc_name || "N/A"}</th>
                                                    </tr>
                                                    <tr>
                                                        <td>Office Address (కార్యాలయ చిరునామా)</td>
                                                        <th>{showData.ddo_ofc_address || "N/A"}</th>
                                                        <td>Phone No. (ఫోన్ నంబర్)</td>
                                                        <th>{showData.ddo_phone_no || "N/A"}</th>
                                                    </tr>
                                                    <tr>
                                                        <td>Email (ఈమెయిల్)</td>
                                                        <th>{showData.ddo_email || "N/A"}</th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                                {showData.usertype === "Executing Agency" && (
                                    <>
                                        <div className="inner-herbpage-service-title-sub">
                                            <h1>Executing Agency Details(అమలు సంస్థ వివరాలు)</h1>
                                        </div>
                                        <div className="personal-row personal-roweducation">
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-striped">
                                                    <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                        <tr>
                                                            <td>Category(వర్గం)</td>
                                                            <th>{showData.category || "N/A"}</th>
                                                            <td>Department Name(శాఖ పేరు)</td>
                                                            <th>{showData.name_of_dept || "N/A"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Agency Name (సంస్థ పేరు)</td>
                                                            <th>{showData.agency_name || "N/A"}</th>
                                                            <td>Agency Address (సంస్థ చిరునామా)</td>
                                                            <th>{showData.agency_address || "N/A"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Authorised Person Name (అధికార ప్రతినిధి పేరు)</td>
                                                            <th>{showData.agency_auth_person_name || "N/A"}</th>
                                                            <td>Phone No. (ఫోన్ నంబర్)</td>
                                                            <th>{showData.agency_phn_no || "N/A"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Email (ఈమెయిల్)</td>
                                                            <th>{showData.agency_email || "N/A"}</th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {(showData?.usertype === "Individual/Company" && showData?.plan_approval === "yes") && (
                                    <>
                                        <div className="inner-herbpage-service-title-sub mt-3">
                                            <h1>Building Location Address (భవనం స్థానం చిరునామా)</h1>
                                        </div>
                                        <div className="personal-row personal-roweducation">
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-striped">
                                                    <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                                        <tr>
                                                            <td>District (జిల్లా)</td>
                                                            <th>{showData.office_district || "N/A"}</th>
                                                            <td>Mandal (మండలం)</td>
                                                            <th>{showData.office_mandal || "N/A"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Village (గ్రామం)</td>
                                                            <th>{showData.office_village || "N/A"}</th>
                                                            <td>Pincode (పిన్ కోడ్)</td>
                                                            <th>{showData.office_pincode || "N/A"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Door No (ఇంటి నంబర్).</td>
                                                            <th>{showData.office_doorno || "N/A"}</th>
                                                            <td>Address (చిరునామా)</td>
                                                            <th>{showData.office_address || "N/A"}</th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </>
                                )}
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Work Details(పని వివరాలు)</h1>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped table-responsive mb-0 mt-1"
                                        style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse' }}
                                    >
                                        <thead style={{ border: "1px solid black" }}>
                                            <tr>
                                                <th>Vendor Name (వెండర్ పేరు)</th>
                                                <th>Work Agreement Number/Id (పని ఒప్పంద సంఖ్య/ఐడీ)</th>
                                                <th>Phone Number(ఫోన్ నంబర్)</th>
                                                <th>Work Address (పని చిరునామా)</th>
                                                <th>Nature of Work (పనితనం స్వభావం)</th>
                                                <th>Value of Work (పని విలువ)</th>
                                                <th>1% Of value of work</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {showData?.work_details?.map((row, index) => (
                                                <tr key={index}>
                                                    <td>{row.vender_name || "N/A"}</td>
                                                    <td>{row.work_bill_no || "N/A"}</td>
                                                    <td>{row.phoneno || "N/A"}</td>
                                                    <td>{row.work_address || "N/A"}</td>
                                                    <td>{row.nature_of_work || "N/A"}</td>
                                                    {/* <td>{row.value_of_work  ? Number(row.value_of_work).toLocaleString('en-IN', { minimumFractionDigits: 2 }) : "0.00"}</td> */}
                                                    <td>{row.value_of_work}</td>
                                                    <td>{row.value_of_work_percentage}</td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {showData && (
                                    <>
                                        <div className="inner-herbpage-service-title-sub">
                                            <h1>Payment Details (చెల్లింపు వివరాలు)</h1>
                                        </div>
                                        <div className="row px-3">
                                            <jnb.Row className='mb-4'>
                                                {/* CESS Amount - Always Disabled */}
                                                <div className="col-md-3 mb-3">
                                                    <label className=' w-100 mb-1'><strong>CESS Amount(సెస్ మొత్తం)</strong></label>
                                                    <Field
                                                        type="text"
                                                        name="cessAmount"
                                                        className="form-control"
                                                        disabled
                                                        value={parseFloat(Formik.values.cessAmount || showData.cess_amount || 0).toFixed(2)}

                                                    />
                                                    <ErrorMessage name="cessAmount" component="div" className="text-error" />
                                                </div>
                                            </jnb.Row>
                                            <div className="col-md-3 mb-3">
                                                <label className=' w-100 mb-1'><strong>Remaining Amount(మిగిలిన మొత్తం)</strong></label>
                                                <Field
                                                    type="text"
                                                    name="RemainingAmount"
                                                    className="form-control"
                                                    disabled
                                                    value={parseFloat(Formik.values.RemainingAmount || showData.remaining_amount || 0).toFixed(2)}
                                                // value={Formik.values.RemainingAmount || ""}
                                                />
                                                <ErrorMessage name="RemainingAmount" component="div" className="text-error" />
                                            </div>


                                            {/* Payment Type - Editable */}
                                            {showData?.payment_type === 'P' && (
                                                <div className="col-md-3 mb-3">
                                                    <label className=' w-100 mb-1'><strong>Payment Type(చెల్లింపు రకం)</strong></label>
                                                    <div className="form-control d-flex gap-3 align-items-center" title="Select the Payment Type(చెల్లింపు రకం ఎంచుకోండి)">
                                                        {/* <Field
            type="radio"
            name="paymentType"
            value="F"
            checked={Formik.values.paymentType === 'F'}
            onChange={() => {
              Formik.setFieldValue("paymentType", "F");
              Formik.setFieldValue("advanCessAmount", "");
              Formik.setFieldValue("balancePayAmount", "0.00");
            }}
          />  */}
                                                        <Field
                                                            type="radio"
                                                            value="F"
                                                            name="paymentType"
                                                            checked={Formik.values.paymentType === 'F'}
                                                            onChange={(e) => {
                                                                const cessAmount = parseFloat(Formik.values.RemainingAmount || showData.remaining_amount || 0).toFixed(2);
                                                                Formik.setFieldValue("paymentType", "F");
                                                                Formik.setFieldValue("advanCessAmount", cessAmount);
                                                                Formik.setFieldValue("balancePayAmount", "0.00");
                                                            }}
                                                        /> Full(పూర్తి)

                                                        <Field
                                                            type="radio"
                                                            name="paymentType"
                                                            value="P"
                                                            checked={Formik.values.paymentType === 'P'}
                                                            onChange={() => {
                                                                Formik.setFieldValue("paymentType", "P");
                                                                Formik.setFieldValue("balancePayAmount", ""); // Will be calculated
                                                                Formik.setFieldValue("advanCessAmount", "");
                                                                Formik.setFieldValue("RemainingAmount", showData?.remaining_amount)
                                                            }}
                                                        /> Partial(భాగంగా)
                                                    </div>
                                                    <ErrorMessage name="paymentType" component="div" className="text-error" />
                                                </div>
                                            )}
                                            {/* Advance Paid CESS - only for Partial */}
                                            {Formik.values.paymentType === 'P' && (
                                                <>
                                                    <div className="col-md-3 mb-3">
                                                        <label className='w-100 mb-1'>Select Vendor Name(వెండర్ పేరు)</label>
                                                        <Field as="select" name="paymentVendorName" className="form-control w-100" onChange={(e) => { Formik.setFieldValue('advanCessAmount', '') }} >
                                                            <option value="">--Select--</option>
                                                            {showData?.work_details !== undefined && showData?.work_details.map((vendor, i) => {
                                                                return (<option key={i} value={vendor.vender_name}>{vendor.vender_name}</option>);
                                                            })}
                                                        </Field>
                                                        <ErrorMessage name="paymentVendorName" component="div" className="text-error" />
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <label className=' w-100 mb-1'><strong>Advance Paid CESS Amount(ముందస్తుగా చెల్లించిన సెస్ మొత్తం)</strong></label>
                                                        <Field
                                                            type="text"
                                                            name="advanCessAmount"
                                                            className="form-control"
                                                            onKeyPress={(e) => handleNumericDot(e)}
                                                            onPaste={(e) => { e.preventDefault() }}
                                                            onDragStart={(e) => e.preventDefault()}
                                                            onDrop={(e) => e.preventDefault()}
                                                            onChange={(e) => {
                                                                const value = parseFloat(e.target.value) || 0;
                                                                const cess = parseFloat(Formik.values.RemainingAmount || showData.remaining_amount || 0);
                                                                const balance = (cess - value).toFixed(2);
                                                                Formik.setFieldValue("advanCessAmount", value);
                                                                Formik.setFieldValue("RemainingAmount", showData?.remaining_amount)
                                                                Formik.setFieldValue("balancePayAmount", balance >= 0 ? balance : "");
                                                            }}
                                                            value={Formik.values.advanCessAmount || ""}
                                                        />
                                                        <ErrorMessage name="advanCessAmount" component="div" className="text-error" />
                                                    </div>
                                                </>)}

                                            {/* Balance Payable Amount - Always Disabled */}
                                            {(Formik.values.paymentType === 'P' || Formik.values.paymentType === 'F') && (
                                                <div className="col-md-3 mb-3">
                                                    <label className=' w-100 mb-1'><strong>Balance Payable Amount(చెల్లించాల్సిన మిగతా మొత్తం)</strong></label>
                                                    <Field
                                                        type="text"
                                                        name="balancePayAmount"
                                                        className="form-control"
                                                        disabled
                                                        value={parseFloat(Formik.values.balancePayAmount || showData.balance_pay_amount || 0).toFixed(2)}
                                                    />
                                                    <ErrorMessage name="balancePayAmount" component="div" className="text-error" />
                                                </div>)}
                                        </div>
                                    </>
                                )}

                                {showData?.payment_type !== 'F' && (
                                    <div className='text-end mt-4'>
                                        <button type="submit" className="btn btn-primary btn-md"
                                            onClick={() => {
                                                payment(Formik.values);
                                            }}
                                        >Procced To Pay</button>
                                    </div>
                                )}


                                <jnb.Row className="pt-1">
                                    <div className="inner-herbpage-service-title-sub">
                                        <h1>Payment History(చెల్లింపుల చరిత్ర)</h1>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-2"
                                            style={{ border: '3px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                                        >
                                            <thead style={{ border: "1px solid black" }}>
                                                <tr>
                                                    <th>S.NO</th>
                                                    <th>Transaction Id (లావాదేవీ ఐడి)</th>
                                                    <th>Vendor Name(వెండర్ పేరు)</th>
                                                    <th>Amount Paid (చెల్లించిన మొత్తం)</th>
                                                    <th>Payment Type (చెల్లింపు రకం)</th>
                                                    <th>Payment Date (చెల్లింపు తేదీ)</th>
                                                    <th>Payment Status (చెల్లింపు స్థితి)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(showData?.payment_details) && showData.payment_details.length > 0 ? (
                                                    showData.payment_details.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.transaction_id || "N/A"}</td>
                                                            <td>{item.vendor_name || "-"}</td>
                                                            <td>{item.transaction_amount?.toFixed(2) || "0.00"}</td>
                                                            <td>
                                                                {item.payment_type === "P"
                                                                    ? "Partial"
                                                                    : item.payment_type === "F"
                                                                        ? "Full"
                                                                        : item.payment_type || "N/A"}
                                                            </td>
                                                            <td>
                                                                {item.payment_status_updated_on
                                                                    ? new Date(item.payment_status_updated_on).toLocaleString("en-GB", {
                                                                        day: "2-digit",
                                                                        month: "2-digit",
                                                                        year: "numeric",
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                        second: "2-digit",
                                                                    }).replace(",", " /")
                                                                    : "N/A"}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    color:
                                                                        item.payment_status?.toUpperCase() === "SUCCESS"
                                                                            ? "green"
                                                                            : item.payment_status?.toUpperCase() === "FAIL"
                                                                                ? "red"
                                                                                : "black",
                                                                    fontWeight: "bold",
                                                                }}
                                                            >
                                                                {item.payment_status || "N/A"}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={6} className="text-center text-danger fw-bold">
                                                            ***  No Payment History Found ***    </td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>

                                </jnb.Row>



                            </>
                        )}


                    </jnb.Form>
                </FormikProvider>
            </jnb.Container>
        </React.Fragment>
    )
}
